<template>
  <MapModal
    :modalNode="modalNode"
    title="模型树"
    id="scenerModel"
    :close="scenerModelClose"
    ref="scenerModel"
    :class="$store.state.isPresentationMode && 'isShowIcon'"
  >
    <template slot="foot" v-if="!$store.state.isPresentationMode">
      <div class="foot-operate" v-if="selectedScene">
        <el-button type="primary" @click="verification">
          加入场景
        </el-button>
      </div>
    </template>
  </MapModal>
</template>
<script>
const MapModal = () => import("@/components/common/mapModal/Index");

//按需加载
import {
  getProjectBimModel,
  addBimPlanScenesBusiness,
  checkBeforeAddList,
} from "@/api/api";
import * as mapWork from "./map.js";
export default {
  name: "scener-model",
  components: { MapModal },
  props: [
    "getSchemeTree",
    "selectedScene",
    "modalNodeData",
    "close",
    "postNewTerrainDiggingDat",
  ],
  data() {
    return {
      show: false,
      checkedIds: [], //页面加载时默认勾选的id
      data: [],
      defaultProps: {
        children: "children",
        label: "title",
      },
      modalNode: {
        planDemo: {
          show: true, // 默认展示
          loading: false, // 加载loading
          offset: {
            // 默认弹出层偏移
            x: 55,
            y: -425,
            // unit: "px", // 默认px
          },
          width: "380px", // 宽度配置 默认450px
          height: `${window.screen.height - 200 - 80}px`, // 配置模态框中心高度
          //模态框head配置
          head: {
            //是否能拖动
            canmove: {
              //当前拖动状态
              state: false,
            },
            //折叠配置
            fold: {
              //当前折叠状态
              state: true,
            },
          },
          // 模态框中心配置
          content: {
            type: "tree", // 模态框内容类型 关键
            // class: "tree-image",
            // imageError: "暂无数据",
            id: "modalTree", // id和ref使用的同一个
            name: "title", // 树的展示字段 默认name
            expand: false,
            // 树形Json 后台接受的具体数据 核心
            treeDataJson: [],
            isExpandList: [],
            checkeArr: [],
            checkeNodeKey: [],
            search: {
              keywords: "title", // 搜素配置关键字 默认是name
            },
            checkBox: true,
            check: this.checkBoxClick,
            nodeClick: this.nodeClick2,
          },
        },
      },
      projectId: window.sessionStorage.getItem("nowProjectId"),
    };
  },
  computed() {
    //计算属性将被混入到 Vue 实例中。所有 getter 和 setter 的 this 上下文自动地绑定为 Vue 实例。
    //注意如果你为一个计算属性使用了箭头函数，则 this 不会指向这个组件的实例，不过你仍然可以将其实例作为函数的第一个参数来访问。
  },
  watch: {},
  filters: {
    //包含 Vue 实例可用过滤器的哈希表。
  },
  beforeCreate() {
    //在实例初始化之后，数据观测 (data observer) 和 event/watcher 事件配置之前被调用。
  },
  created() {
    //在实例创建完成后被立即调用。在这一步，实例已完成以下的配置：数据观测 (data observer)，property 和方法的运算，watch/event 事件回调。然而，挂载阶段还没开始，el property 目前尚不可用。
  },
  beforeMount() {
    //在挂载开始之前被调用：相关的 render 函数首次被调用。
  },
  methods: {
    scenerModelClose() {
      this.close("model");
    },
    // 选中事件
    handleNodeClickChange(data, status) {
      // console.log(data);
      if (data && data.children.length < 1) {
        if (!data.bimModel.type) {
          if (data.bimModel.version === "wms") {
            //为线位
            if (data.imageryLayer) {
              let layer = this.$GLOBAL.map.getLayerById(data.imageryLayer);
              if (layer) {
                this.$GLOBAL.map.removeLayer(layer); //移除layer。
                this.$parent.deleteSceneResources("model", data.imageryLayer);
              }
              data.imageryLayer = 0;
              let eIndex = this.$GLOBAL.checkedIds.indexOf(data.id);
              if (eIndex !== -1) {
                this.$GLOBAL.checkedIds.splice(eIndex, 1);
              }
            }
            //layer.show = status;

            if (status) {
              //展示数据
              let wmsProvider = new mars3d.layer.WmsLayer({
                //url: 'http://bim-dev:8080/geoserver/WuYuProjects/wms',
                //layers: layers[i],
                url: data.bimModel.modelUrl,
                layers: data.bimModel.modelName,
                parameters: {
                  transparent: true, //是否透明
                  format: "image/png", //application/openlayers
                  srs: "EPSG:4326",
                  styles: "",
                },
                show: true,
                hasZIndex: true,
                zIndex: data.bimModel.order || 100,
              });
              this.$GLOBAL.map.addLayer(wmsProvider);
              data.imageryLayer = wmsProvider.id;
              this.$GLOBAL.checkedIds.push(data.id);
            }
          } else {
            //为模型
            if (data.cesium3DTilesetIndex) {
              let cesium3DTileset = this.$GLOBAL.map.getLayerById(
                data.cesium3DTilesetIndex
              );
              if (cesium3DTileset) {
                this.$GLOBAL.map.removeLayer(cesium3DTileset, true); //先移除旧的layer。
                this.$parent.deleteSceneResources(
                  "model",
                  data.cesium3DTilesetIndex
                );
              }
              //如果勾选项含当前选中项，则取消当前选中项的高亮【因为可以通过勾选父节点一次勾选多个模型，此举为避免混乱】。
              if (this.currentLayerId === data.cesium3DTilesetIndex) {
                window.sessionStorage.removeItem("currentLayerId");
                this.currentLayerId = "";
                if (cesium3DTileset) {
                  cesium3DTileset.closeHighlight();
                }
                if (this.$refs.tree) {
                  this.$refs.tree.setCurrentKey(null);
                }
              }
              data.cesium3DTilesetIndex = 0;
              let eIndex = this.$GLOBAL.checkedIds.indexOf(data.id);
              if (eIndex !== -1) {
                this.$GLOBAL.checkedIds.splice(eIndex, 1);
              }
            }
            if (status) {
              //展示数据
              let tilesetLayer = this.mapData(data);
              console.log(tilesetLayer);
              data.cesium3DTilesetIndex = tilesetLayer.id;
            }
          }
        }
      }
    },
    nodeClick2() {},
    // 点击当前数据
    nodeClick(data, status) {
      console.log(data);
      if (data && data.children.length < 1) {
        // if (status.checked) {
        let layer = mapWork.ifModel(data.id),
          addlayer;
        if (layer) {
          mapWork.positioningModel(layer);
        } else {
          addlayer = this.addModel(data, "click");
          window.sessionStorage.setItem("currentLayerId", addlayer.uuid);
          mapWork.positioningModel(addlayer);
        }
      }
    },
    // 勾选
    checkBoxClick(data, status) {
      console.log("模型树勾选");
      if (typeof status == "boolean" && data && data.children.length < 1) {
        let layer;
        layer = mapWork.ifModel(data.id);
        // if (layer) {
        //   mapWork.deleteModel(layer);
        // } else {
        //   mapWork.deleteModel({
        //     options: {
        //       modelId: data.id,
        //     },
        //   });
        // }
        // if (status) {
        //   // console.log(layer);
        //   // this.addModel(data, "check");
        // }
      } else {
        // 此次需要用递归处理获取子级所有数据
        let state;
        if (typeof status == "boolean") {
          state = status;
        } else {
          state = status.checkedKeys.indexOf(data.id) >= "0";
        }

        if (data.children.length == 0) {
          this.checkBoxClick(data, state);
        } else {
          data.children.forEach((item) => {
            this.checkBoxClick(item, state);
          });
        }
      }
    },
    // 获取树
    getScenerModelTree() {
      this.modalNode.planDemo.loading = true;
      let modelData = {
        ProjectId: this.projectId,
        CategoryName: "子分项工程",
      };
      getProjectBimModel(modelData).then((res) => {
        //对数据进行处理，添加线位
        let { dataList, isExpandList } = res.data.data;
        this.modalNode.planDemo.loading = false;
        this.modalNode.planDemo.content.treeDataJson = this.recursion(dataList);
        this.modalNode.planDemo.content.isExpandList = isExpandList;
      });
    },

    enter(e) {
      if (e.permission) {
        let uid = this.addModel(e, "resourceRelease").id;
        e.uid = uid;
      }
    },
    leave(e) {
      if (e.permission) {
        this.$GLOBAL.map.removeLayer(e.uid, true);
      }
    },
    // 搜索
    filterNode(value, data) {
      if (!value) return true;
      return data.title.indexOf(value) !== -1;
    },
    // 递归处理树数据
    recursion(data) {
      const threeObj = [
        {
          i_icon: "small-operation-btn el-icon-view",
          click: (e) => this.ifExhibitionModel(e),
        },
      ];

      data.forEach((item) => {
        if (item.children.length > 0) {
          this.recursion(item.children);
          item.operate = threeObj;
        } else {
          item.operate = [
            {
              i_icon: "small-operation-btn el-icon-airplane",
              click: (e) => this.nodeClick(e),
            },
            ...threeObj,
          ];
          // if (this.checkedIds.indexOf(item.id) >= 0) {
          //   this.addModel(item, "init");
          // }
          // item.operate = [threeObj];
        }
      });
      // console.log(checkeArr);
      return data;
    },
    ifExhibitionModel(e) {
      window.sessionStorage.removeItem("currentLayerId");
      if (e.children.length > 0) {
        e.children.forEach((item) => {
          this.ifExhibitionModel(item);
        });
      } else {
        console.log(e);
        let layer = mapWork.ifModel(e.id);
        if (layer) {
          mapWork.deleteModel(layer);
        } else {
          this.addModel(e, "check");
        }
      }
    },
    // 添加模型逻辑 其中包含了 处理动态加载逻辑
    addModel(item, type) {
      let data;
      data = mapWork.addModel(
        item,
        type,
        (e) => {
          // 处理动态加载逻辑
          item.uid = e.layer.uuid;
          let viewShedItem =
            Object.keys(viewShed).length == 0
              ? undefined
              : viewShed.inquire(
                  "modelArray",
                  "modelId",
                  e.layer.options.modelId
                );
          if (viewShedItem != undefined) {
            viewShedItem.uid = e.layer.uuid;
          } else {
            viewShed.add("modelArray", {
              permission: e.layer.options.permission,
              modelId: e.layer.options.modelId,
              modelType: e.layer.options.modelType,
              url: decodeURI(e.layer.options.url),
              uid: e.layer.uuid,
              center: e.layer._center,
              customize: e.layer.options.customize,
            });
          }

          if (e.layer.options.permission && type == "init") {
            queueMicrotask(() => {
              this.$GLOBAL.map.removeLayer(e.layer.options.id, true);
            });
          }
        },
        (e) => {
          console.log(e);
          // this.$emit("postNewTerrainDiggingDat", e);
          this.postNewTerrainDiggingDat(e);
          let { layer } = e;
          if (this.$refs.scenerModel) {
            this.setCurrentKey(layer.options.modelId);
          }
        }
      );
      return data;
    },
    // 高亮显示当前项
    setCurrentKey(id) {
      this.$refs.scenerModel.$refs.modalTree[0].setCurrentKey(id);
    },
    checkAllChange() {
      this.$refs.scenerModel.$refs.modalTree[0].checkAllChange();
    },
    removeAllChange() {
      this.$refs.scenerModel.$refs.modalTree[0].removeAllChange();
    },
    verification() {
      console.log(this.modalNodeData);
      let currentNode = this.$refs.scenerModel.$refs.modalTree[0].getCurrentNode();
      this.modalNode.planDemo.loading = true;
      let businessId = [];
      currentNode.forEach((item) => {
        businessId.push(item.bimModel.id);
      });
      let data = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: businessId,
        // 业务类型
        businessType: "BimModel",
      };
      checkBeforeAddList(data)
        .then((res) => {
          let { code, data } = res.data;
          if (code == 200 || code == 204) {
            if (data && data.cOperateIds.length > 0) {
              this.modalNode.planDemo.loading = false;
              this.$message({
                showClose: true,

                message: `操作（ID：${data.pModelIds.toString()}）中使用了资源：${data.dataName.join(
                  "，"
                )}。被占用资源无法取消勾选，请检查！`,
                duration: 0,
                type: "error",
              });
            } else {
              this.modalNode.planDemo.loading = false;
              this.onSubmit([]);
            }
          } else {
            this.modalNode.planDemo.loading = false;
            this.$notify({
              title: "网络不佳",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.modalNode.planDemo.loading = false;
          this.$notify({
            title: "网络不佳",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
      // this.getSchemeTree();

      // this.$confirm("此操作将删除关于此模型的所有操作, 是否继续?", "提示", {
      //   confirmButtonText: "确定",
      //   cancelButtonText: "取消",
      //   type: "warning",
      // })
      //   .then(() => {
      //     this.onSubmit();
      //   })
      //   .catch(() => {
      //     this.$message({
      //       type: "info",
      //       message: "取消",
      //     });
      //   });
    },
    // 加入场景
    onSubmit(operateIdLsit) {
      // console.log(this.$refs.scenerModel.$refs.modalTree[0].getCurrentNode());
      let currentNode = this.$refs.scenerModel.$refs.modalTree[0].getCurrentNode();
      this.modalNode.planDemo.loading = true;
      let businessId = [];
      currentNode.forEach((item) => {
        businessId.push(item.bimModel.id);
      });
      let data = {
        // 场景id
        scenesId: this.selectedScene.id,
        // 项目id
        projectId: window.sessionStorage.getItem("nowProjectId"),
        // 业务id
        businessIdLsit: businessId,
        // 业务类型
        businessType: "BimModel",
        operateIdLsit: operateIdLsit || [],
      };
      addBimPlanScenesBusiness(data)
        .then((res) => {
          let { code } = res.data;
          if (code == 200 || code == 204) {
            this.modalNode.planDemo.loading = false;
            this.getSchemeTree();
            this.$notify({
              title: "加入场景成功",
              message: "",
              type: "success",
              duration: 960,
              offset: 320,
            });
            try {
              this.scenerModelClose();
            } catch (err) {}
          } else {
            this.$notify({
              title: "加入场景失败",
              message: "",
              type: "error",
              duration: 1000,
              offset: 320,
            });
          }
        })
        .catch((error) => {
          console.log(error);
          this.modalNode.planDemo.loading = false;
          this.$notify({
            title: "加入场景失败",
            message: "",
            type: "error",
            duration: 1000,
            offset: 320,
          });
        });
      // this.getSchemeTree();
    },
    // 初始化
    init() {
      this.getScenerModelTree();

      // if (this.selectedScene?.treeDataJson[0].children.length > 0) {
      //   this.selectedScene.treeDataJson[0].children.forEach((item) => {
      //     this.checkedIds.push(item.bimModel.embsId);
      //   });
      // }
    },
  },
  mounted() {
    this.init();
  },
  watch: {
    modalNodeData: function(newVal, oldVal) {
      newVal[0].children.forEach((item) => {
        this.checkedIds.push(item.bimModel.embsId);
        // this.modalNode.planDemo.content.checkeArr = this.checkedIds;
      });
      this.$refs.scenerModel.$refs.modalTree[0].checkChangeArr(this.checkedIds);
    },
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/scss/index.scss";

.isShowIcon {
  // /deep/ .el-icon-view {
  //   display: none !important;
  // }
}
.el-scrollbar__bar.is-vertical {
  width: 6px;
  top: 2px;
}
.el-scrollbar__bar {
  position: absolute;
  right: 2px;
  bottom: 2px;
  z-index: 1;
  border-radius: 4px;
  opacity: 0;
  transition: opacity 120ms ease-out;
}
.treeShape {
  background: none;
  @include elTreeNode2();
  max-height: initial;
  min-height: 100px;
}

.table {
  @include box_wh(320, 0);
  height: auto;
  // max-height: 500px;
  padding: 0;
  transition-property: max-height, width, overflow;
  transition-duration: 0.3s, 0.3s, 0.3s;
}
.foot-operate {
  padding: 10px 10px;
  border-top: 1px solid rgba(245, 245, 245, 0.6) !important;
  justify-content: flex-end;
  align-items: center;
  display: flex;
  /deep/ .el-button {
    margin: 0;
    font-size: 14px;
    padding: 3px 10px;
    line-height: inherit;
    height: auto;
  }
}
/deep/.el-message.is-closable .el-message__content {
  line-height: 1.2;
}
</style>
